import { BaseEntity } from "../base/base-entity";

export type OrganizationSessionSetting = {
  idleSessionTimeoutSecond: number;
};

type OrganizationSessionSettingError = {
  idleSessionTimeoutSecond?: string;
};

export class OrganizationSessionSettingEntity extends BaseEntity {
  idleSessionTimeoutSecond: number;

  constructor(value: OrganizationSessionSetting) {
    super();
    this.idleSessionTimeoutSecond = value.idleSessionTimeoutSecond;
  }

  static fromJSON(value: OrganizationSessionSetting) {
    return new OrganizationSessionSettingEntity(value);
  }

  get idleSessionTimeoutToJapaneseHours(): string {
    const hours = Math.floor(this.idleSessionTimeoutSecond / (60 * 60));
    return `${hours}時間`;
  }

  get idleSessionTimeoutSecondValue(): string {
    return this.idleSessionTimeoutSecond.toString();
  }
}

export class OrganizationSessionSettingValdiator {
  constructor(private setting: OrganizationSessionSettingEntity | null) {}

  private minIdleSessionTimeoutSecond = 60 * 60;
  private maxIdleSessionTimeoutSecond = 60 * 60 * 12;

  isValid(): boolean {
    return Object.values(this.validationError).every((v) => v === undefined);
  }

  private get validationError(): OrganizationSessionSettingError {
    return {
      idleSessionTimeoutSecond: this.validIdleSessionTimeoutSecond,
    };
  }

  get validIdleSessionTimeoutSecond(): string | undefined {
    if (!this.setting) {
      return undefined;
    }

    if (
      this.setting.idleSessionTimeoutSecond < this.minIdleSessionTimeoutSecond
    ) {
      return "セッションタイムアウトは1時間以上に設定してください。";
    }

    if (
      this.setting.idleSessionTimeoutSecond > this.maxIdleSessionTimeoutSecond
    ) {
      return "セッションタイムアウトは12時間以下に設定してください。";
    }

    return undefined;
  }
}

const range = (start: number, end: number): number[] =>
  Array.from({ length: end - start + 1 }, (_, i) => start + i);

// 設定可能なセッションタイムアウトのリスト
// 1時間 ~ 6時間の間で設定可能
export const availableIdleSessionTimeouts: OrganizationSessionSettingEntity[] =
  range(1, 12).map(
    (v) =>
      new OrganizationSessionSettingEntity({
        idleSessionTimeoutSecond: 60 * 60 * v,
      }),
  );
